import '~/webpack';
import '~/commons';
import { initSuperSidebar, initSuperSidebarToggle } from '~/super_sidebar/super_sidebar_bundle';

initSuperSidebar();
initSuperSidebarToggle();
